export default "__VITE_ASSET__hyvpJYBk__"